<template>
  <section class="hero-block">
    <div class="hero-block__container">
      <!-- Заголовок по левому краю -->
      <div class="hero-block__title-wrapper" v-if="data.title">
        <h1 class="hero-block__title">{{ data.title }}</h1>
      </div>

      <!-- Текст под заголовком -->
      <div class="hero-block__description-wrapper" v-if="data.description">
        <p class="hero-block__description">{{ data.description }}</p>
      </div>

      <!-- Изображение под текстом -->
      <div v-if="data.image" class="hero-block__image-wrapper">
        <img
            :src="data.image"
            :alt="data.title || 'Изображение'"
            class="hero-block__image"
        />
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'AppCustomHeroBlock',
  props: {
    data: {
      type: Object,
      required: true,
      default: () => ({})
    }
  }
};
</script>

<style scoped lang="scss">

$primary-green: #38613a;
$dark-green: #1B5E20;
$dark-gray: #555;
$white: #ffffff;
$shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
$border-radius: 20px;
$transition: all 0.3s ease;

.hero-block {
  display: flex;
  justify-content: center;



  @media (max-width: 480px) {
    padding: 10px 15px;
  }
}

.hero-block__container {
  max-width: 1600px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 40px;
  padding: 0;


  @media (max-width: 1024px) {
    gap: 35px;
  }

  @media (max-width: 768px) {
    gap: 30px;
    text-align: center;
  }

  @media (max-width: 480px) {
    padding: 25px 20px;
    gap: 25px;
  }
}

.hero-block__title-wrapper {
  width: 100%;
  text-align: left;
  padding-top: 15px;

  @media (max-width: 1024px) {
    text-align: center;
  }
}

.hero-block__title {
  font-family: 'TTDrugs', sans-serif;
  font-size: 40px;
  font-weight: 700;
  line-height: 1.1;
  color: $primary-green;
  text-transform: uppercase;
  margin: 0;
  max-width: 80%;

  text-align: left;
  display: inline-block;

  @media (max-width: 1024px) {
    font-size: 42px;
    max-width: 90%;
    text-align: center;
  }

  @media (max-width: 768px) {
    font-size: 36px;
    max-width: 100%;
  }

  @media (max-width: 480px) {
    font-size: 32px;
  }

  @media (max-width: 360px) {
    font-size: 28px;
  }
}

.hero-block__description-wrapper {
  width: 100%;
  text-align: left;

  @media (max-width: 768px) {
    text-align: center;
  }
}

.hero-block__description {
  font-family: 'Circe', sans-serif;
  font-size: 20px;
  font-weight: 300;
  line-height: 1.7;
  color: $dark-gray;
  margin: 0;
  max-width: 90%;

  text-align: left;
  display: inline-block;

  @media (max-width: 1024px) {
    font-size: 20px;
    max-width: 95%;
  }

  @media (max-width: 768px) {
    font-size: 18px;
    max-width: 100%;
    text-align: center;
  }

  @media (max-width: 480px) {
    font-size: 17px;
    line-height: 1.6;
  }
}

.hero-block__image-wrapper {
  width: 100%;
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.hero-block__image {
  width: 100%;
  height: auto;
  max-height: 800px;
  object-fit: cover;
  object-position: center;
  border-radius: 20px !important;
  transition: $transition;
  display: block;

  @media (max-width: 1024px) {
    max-height: 450px;
  }

  @media (max-width: 768px) {
    max-height: 350px;
    border-radius: 10px;
  }

  @media (max-width: 480px) {
    max-height: 280px;
    border-radius: 8px;
  }

  @media (max-width: 360px) {
    max-height: 220px;
  }
}
</style>